/** 深度过滤目标对象（移除符合特定特征数据），支持循环引用，返回处理结果（新的对象） */
export function deepFilter(obj: any, fn: Function, cache: any[] = []): any {
  if (!obj || typeof obj !== 'object') return obj

  // 如果obj命中，则当前为循环引用
  const hit = cache.find(c => c.original === obj)
  if (hit) return hit.copy

  const copy: any = Array.isArray(obj) ? [] : {}

  // 将copy放入缓存以备后续检查循环引用
  cache.push({ original: obj, copy })

  Object.keys(obj).forEach(key => {
    const flag = fn(obj, key)

    if (flag !== false) {
      copy[key] = deepFilter(obj[key], fn, cache)
    }
  })

  return copy
}

/**
 * 获取日期星期几
 * @param date
 */
export function getWeekText(date?: Date) {
  date = date || new Date()

  const weekStrs = ['日', '一', '二', '三', '四', '五', '六']

  return '星期' + weekStrs[date.getDay()]
}
